/* eslint-disable */
import { useEffect } from "react";
import { useDispatch } from "react-redux";


const userID = parseInt(localStorage.getItem("userID"));
const token = localStorage.getItem("token");

const ShippingAndDeliveryPolicy = () => {

    const dispatch = useDispatch();

    useEffect(() => {

        // eslint-disable-next-line
    }, []);

    return (
        <div style={{ padding: '3vw' }}>
            <p style={{ fontWeight: 'bold', fontSize: '40px' }}>
                Shipping and Delivery Policy
            </p>

            <p>
                Thank you for considering donating to our organization. As our donations are received electronically, we do not ship physical products, and therefore we do not have a traditional shipping and delivery policy.
            </p>

            <p style={{ fontWeight: 'bold' }}>
                Order Processing and Donation Confirmation:
            </p>

            <p>
                Once you complete your donation, you will receive a confirmation email to the email address you provided during the donation process from Razorpay. This email will serve as your receipt and will include details of your donation amount and any applicable tax deductions.
            </p>

            <p style={{ fontWeight: 'bold' }}>
                Shipping Costs:
            </p>

            <p>
                As we do not ship physical products, there are no shipping costs associated with our donation process.
            </p>

            <p style={{ fontWeight: 'bold' }}>
                International Donations:
            </p>

            <p>
                We accept donations from donors worldwide. However, please note that international donors are responsible for complying with all applicable laws and regulations related to their donation. If you are an international donor, please be aware that the currency exchange rate may affect the amount you are donating, and any fees or charges applied by your bank or payment processor are your responsibility.
            </p>

            <p style={{ fontWeight: 'bold' }}>
                Processing Time:
            </p>

            <p>
                Donations are typically processed immediately upon submission, and you should receive your confirmation email within a few minutes of completing your donation. If you do not receive your confirmation email within an hour of submitting your donation, please contact us at {process.env.REACT_APP_CONTACT_EMAIL}.
            </p>

            <p style={{ fontWeight: 'bold' }}>
                Effective Date:
            </p>

            <p>
                This Shipping and Delivery Policy is effective as of 13-03-2023.
            </p>

        </div>

    )
}

export default ShippingAndDeliveryPolicy;